export default __webpack_public_path__ + "static/media/s4img9.22f9e18d.webp";